import {
    FAILURE_SCELLIUS_FORM_TOKEN,
    RECEIVE_SCELLIUS_FORM_TOKEN,
    REQUEST_SCELLIUS_FORM_TOKEN,
    RESET_SCELLIUS
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import { makeActionCreator } from '../../utils/actionsUtils';

import { CALL_API } from '../../middlewares/api';

export const reset = makeActionCreator(RESET_SCELLIUS);

export const generateScelliusFormToken = (orderId, partnerId, userInfo) => {
    return {
        [CALL_API]: {
            endpoint: '/scellius/generate-form-token',
            body: { orderId, partnerId, ...userInfo, saveAddress: true },
            types: [
                REQUEST_SCELLIUS_FORM_TOKEN,
                RECEIVE_SCELLIUS_FORM_TOKEN,
                FAILURE_SCELLIUS_FORM_TOKEN
            ],
            method: HTTP_METHOD_POST
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/scellius/actions.js